import { render, staticRenderFns } from "./ProductsItem.vue?vue&type=template&id=a10e1a68&scoped=true&"
import script from "./ProductsItem.vue?vue&type=script&lang=ts&"
export * from "./ProductsItem.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsItem.vue?vue&type=style&index=0&id=a10e1a68&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a10e1a68",
  null
  
)

export default component.exports